module.exports = __webpack_public_path__ + "img/profess2.69aba7b6.png";